(function () {
  'use strict';

  var SECTION_TYPE = 'home-product-carousel';
  var DESKTOP_QUERY = '(min-width: 1024px)';
  var instances = {};

  function HomeProductCarousel(root) {
    this.root = root;
    this.teardowns = [];

    this.tablist = root.querySelector('[role="tablist"]');
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));

    if (this.tabs.length) {
      this.bindTabs();
      this.syncOrientation();
    }

    this.bindTracks();
  }

  HomeProductCarousel.prototype.bindTabs = function () {
    var self = this;

    this.tabs.forEach(function (tab, index) {
      var onClick = function () {
        self.selectTab(index, false);
      };
      var onKeydown = function (event) {
        self.onTabKeydown(event, index);
      };

      tab.addEventListener('click', onClick);
      tab.addEventListener('keydown', onKeydown);

      self.teardowns.push(function () {
        tab.removeEventListener('click', onClick);
        tab.removeEventListener('keydown', onKeydown);
      });
    });

    if (window.matchMedia) {
      var mql = window.matchMedia(DESKTOP_QUERY);
      var onChange = function () {
        self.syncOrientation();
      };

      if (mql.addEventListener) {
        mql.addEventListener('change', onChange);
        this.teardowns.push(function () {
          mql.removeEventListener('change', onChange);
        });
      } else if (mql.addListener) {
        mql.addListener(onChange);
        this.teardowns.push(function () {
          mql.removeListener(onChange);
        });
      }

      this.mql = mql;
    }
  };

  HomeProductCarousel.prototype.isDesktop = function () {
    return this.mql ? this.mql.matches : false;
  };

  HomeProductCarousel.prototype.syncOrientation = function () {
    if (!this.tablist) return;
    this.tablist.setAttribute('aria-orientation', this.isDesktop() ? 'vertical' : 'horizontal');
  };

  HomeProductCarousel.prototype.selectTab = function (index, moveFocus) {
    var self = this;

    this.tabs.forEach(function (tab, i) {
      var selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');

      if (selected && moveFocus) tab.focus();
      if (selected && !self.isDesktop() && tab.scrollIntoView) {
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    });

    this.panels.forEach(function (panel, i) {
      if (i === index) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    this.refreshTracks();
  };

  HomeProductCarousel.prototype.onTabKeydown = function (event, index) {
    var last = this.tabs.length - 1;
    var next = null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = index === last ? 0 : index + 1;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = index === 0 ? last : index - 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.selectTab(next, true);
  };

  HomeProductCarousel.prototype.bindTracks = function () {
    var self = this;  

    this.viewports = Array.prototype.slice.call(
      this.root.querySelectorAll('.home-product-carousel__viewport')
    ).map(function (viewport) {
      var track = viewport.querySelector('[data-carousel-track]');
      var prev = viewport.querySelector('[data-carousel-arrow="prev"]');
      var next = viewport.querySelector('[data-carousel-arrow="next"]');
      if (!track) return null;

      var entry = { viewport: viewport, track: track, prev: prev, next: next };

      var onScroll = function () {
        self.updateArrows(entry);
      };
      track.addEventListener('scroll', onScroll, { passive: true });
      self.teardowns.push(function () {
        track.removeEventListener('scroll', onScroll);
      });

      [
        [prev, -1],
        [next, 1]
      ].forEach(function (pair) {
        var button = pair[0];
        var direction = pair[1];
        if (!button) return;

        var onClick = function () {
          self.scrollByPage(entry, direction);
        };
        button.addEventListener('click', onClick);
        self.teardowns.push(function () {
          button.removeEventListener('click', onClick);
        });
      });

      return entry;
    }).filter(Boolean);

    var onResize = function () {
      self.refreshTracks();
    };

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(onResize);
      observer.observe(this.root);
      this.teardowns.push(function () {
        observer.disconnect();
      });
    } else {
      window.addEventListener('resize', onResize);
      this.teardowns.push(function () {
        window.removeEventListener('resize', onResize);
      });
    }

    this.refreshTracks();
  };

  HomeProductCarousel.prototype.cardWidth = function (entry) {
    var card = entry.track.querySelector('.home-product-carousel__card');
    return card ? card.getBoundingClientRect().width : 0;
  };

  HomeProductCarousel.prototype.pageSize = function (entry) {
    var cardWidth = this.cardWidth(entry);
    if (!cardWidth) return entry.track.clientWidth;

    var perPage = Math.max(1, Math.floor(entry.track.clientWidth / cardWidth));
    return perPage * cardWidth;
  };

  HomeProductCarousel.prototype.edgeTolerance = function (entry) {
    var cardWidth = this.cardWidth(entry);
    return cardWidth ? Math.max(2, cardWidth * 0.1) : 2;
  };

  HomeProductCarousel.prototype.pagePositions = function (entry) {
    var track = entry.track;
    var maxScroll = track.scrollWidth - track.clientWidth;
    var step = this.pageSize(entry);
    var positions = [0];

    if (step > 0) {
      for (var pos = step; pos < maxScroll - 1; pos += step) positions.push(pos);
    }

    if (maxScroll > 0 && positions[positions.length - 1] !== maxScroll) positions.push(maxScroll);

    return positions;
  };

  HomeProductCarousel.prototype.scrollByPage = function (entry, direction) {
    var track = entry.track;
    var positions = this.pagePositions(entry);
    var current = 0;
    var smallest = Infinity;

    for (var i = 0; i < positions.length; i++) {
      var distance = Math.abs(positions[i] - track.scrollLeft);
      if (distance < smallest) {
        smallest = distance;
        current = i;
      }
    }

    var index = Math.max(0, Math.min(current + direction, positions.length - 1));

    track.scrollTo({ left: positions[index], behavior: 'auto' });
    this.updateArrows(entry);
  };

  HomeProductCarousel.prototype.refreshTracks = function () {
    var self = this;
    (this.viewports || []).forEach(function (entry) {
      self.updateArrows(entry);
    });
  };

  HomeProductCarousel.prototype.updateArrows = function (entry) {
    if (!entry.prev && !entry.next) return;

    if (entry.viewport.offsetParent === null && entry.track.clientWidth === 0) return;

    var maxScroll = entry.track.scrollWidth - entry.track.clientWidth;
    var overflows = maxScroll > 1;
    var position = entry.track.scrollLeft;

    [entry.prev, entry.next].forEach(function (button) {
      if (!button) return;
      if (overflows) {
        button.removeAttribute('hidden');
      } else {
        button.setAttribute('hidden', '');
      }
    });

    var edge = this.edgeTolerance(entry);
    if (entry.prev) entry.prev.disabled = position <= edge;
    if (entry.next) entry.next.disabled = position >= maxScroll - edge;
  };

  HomeProductCarousel.prototype.destroy = function () {
    this.teardowns.forEach(function (off) {
      off();
    });
    this.teardowns = [];
  };

  function initQuickShop() {
    if (window.theme && typeof window.theme.initQuickShop === 'function') {
      window.theme.initQuickShop();
    }
  }

  function init(container) {
    var scope = container || document;
    var roots = scope.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]');

    Array.prototype.forEach.call(roots, function (root) {
      var id = root.getAttribute('data-section-id');
      if (instances[id]) instances[id].destroy();
      instances[id] = new HomeProductCarousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    initQuickShop();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var id = event.detail && event.detail.sectionId;
    if (id && instances[id]) {
      instances[id].destroy();
      delete instances[id];
    }
  });
})();
